/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { filterCampusVirtual, requestGetAllCampus, requestGetAllDays } from "services/general";
import { requestGetResourceModules } from "services/settings/scheduleAdmin/relatedToScheduleAdmin";
import { requestGetLibraries, requestGetResourceTypes } from "services/resources/library/relatedToLibraryResources";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
import { CAMPUS_SPACE_IDS_BY_USER_ROLE } from "config/userPermissions";
import { requestGetSpaceTypes } from "services/resources/universitySpaces/relatedToUniversitySpaceResources";
import { RESOURCE_MODULE_IDS } from "config/constants";
//#endregion

const useDataRelatedToResourceScheduleAdmin = ({
    loadingRequest, resourceModuleId,
    userRole, isSuperadmin
}) => {
    const mainContext = useMainContext();
    //#region States
    const [campusList, setCampusList] = useState([]);
    const [resourceModuleList, setResourceModuleList] = useState([]);
    const [spaceTypeList, setSpaceTypeList] = useState([]);
    const [libraryList, setLibraryList] = useState([]);
    const [resourceTypes, setResourceTypes] = useState([]);
    const [allDays, setAllDays] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (resourceModuleId || isSuperadmin)
            fillData();
    }, [resourceModuleId]);
    //#endregion
    //#region Functions
    async function fillData() {
        loadingRequest.show();
        try {
            let promises = [
                fillCampusList(),
                fillResourceModuleList(),
                fillAllDays()
            ];
            if (isSuperadmin || resourceModuleId === RESOURCE_MODULE_IDS.LIBRARY)
                promises = [
                    ...promises,
                    fillLibraryList(),
                    fillResourceTypes()
                ];
            if (isSuperadmin || resourceModuleId === RESOURCE_MODULE_IDS.UNIVERSITY_SPACES)
                promises = [
                    ...promises,
                    fillSpaceTypeList()
                ];
            await Promise.all(promises);
        }
        catch (err) {
            mainContext.setShowDialogUnexpectedError(true);
        }
        finally {
            loadingRequest.hide();
        }
    }
    async function fillCampusList() {
        const data = await requestGetAllCampus();
        setCampusList(filterCampusVirtual(data));
    }
    async function fillResourceModuleList() {
        const data = await requestGetResourceModules();
        setResourceModuleList(data.filter(({ id }) => CAMPUS_SPACE_IDS_BY_USER_ROLE[id].includes(userRole)));
    }
    async function fillLibraryList() {
        const data = await requestGetLibraries();
        setLibraryList(data);
    }
    async function fillResourceTypes() {
        const data = await requestGetResourceTypes();
        setResourceTypes(data);
    }
    async function fillSpaceTypeList() {
        const data = await requestGetSpaceTypes();
        setSpaceTypeList(data);
    }
    async function fillAllDays() {
        const data = await requestGetAllDays();
        setAllDays(data);
    }
    //#endregion
    return {
        campusList, resourceModuleList,
        libraryList, resourceTypes,
        spaceTypeList, allDays
    };
}

export default useDataRelatedToResourceScheduleAdmin;